import type { TicketUpdate } from '@/types/parentTicket'

export function formatUpdateDate(iso: string): string {
  return new Date(iso).toLocaleString('en-PH', {
    timeZone: 'Asia/Manila',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

export function formatUpdateRelative(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime()
  const mins = Math.floor(diffMs / 60_000)
  if (mins < 1) return 'Just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  return formatUpdateDate(iso)
}

export function updateAuthorName(u: TicketUpdate): string {
  return u.author?.full_name?.trim() || 'Agent'
}

export function updateAuthorInitial(name: string): string {
  return (name.trim()[0] ?? '?').toUpperCase()
}

export function pickLatestUpdate(updates: TicketUpdate[]): TicketUpdate | null {
  if (updates.length === 0) return null
  const sorted = [...updates].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  )
  const comment = sorted.find((u) => u.type === 'comment')
  return comment ?? sorted[0]
}
